import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import SearchQuery from "ulysses/widgets/search/search_query";
import search_columns from "ulysses/widgets/search/search_columns";
import select_facet_column_dialog from "ulysses/widgets/search/select_facet_column.html";
import Facet from "./faceting/list";
import MultiFacet from "./faceting/multi_list";
import NumRangeFacet from "./faceting/num_range";
import DateRangeFacet from "./faceting/date_range";
import IntRangeFacet from "./faceting/int_range";
import TextFacet from "./faceting/text";

"use strict";

class FacetHelper {
    constructor(search_model, settings_obs, context) {
        Object.assign(this, {
            active: ko.observableArray([]),
            widgets: ko.observableArray([]),
            panel_widgets: ko.observableArray([]),
            custom: ko.observableArray([]),
            custom_controls: ko.observableArray([]),
            controls: ko.observableArray([]),
            editing: ko.observable(false),
            search_model: search_model,
            settings_obs: settings_obs,
            context: context
        });
        var custom_facets = ko.unwrap(ko.unwrap(settings_obs).custom_facets);
        this.custom(custom_facets || []);
        var custom_controls = ko.unwrap(settings_obs).custom_controls || [];
        this.custom_controls(custom_controls);
        var that = this;
        this.unselect_facet = (val) => {
            that.removeFilter(val);
        }
        this.add_facet = () => {
            that.chooseAndAddFacet();
        }
        this.remove_facet = (val) => {
            that.removeFacet(val);
        }
        this.add_control = () => {
            that.chooseAndAddControl();
        }
        this.remove_control = (val) => {
            that.removeControl(val);
        }
        this.edit_facets = () => {
            that.search_model.faceting.editing(!that.search_model.faceting.editing());
        }
        this.upgrade_facet = (val) => {
            that.upgradeFacet(val);
        }
        this.reset_facets = () => { that.resetFacets(); }
    }

    removeFilter(val) {
        console.error("boh:", this, arguments);
        this.search_model.faceting.active.remove(val);
        this.search_model.pager.start_index(0);
        this.search_model.query_results();
    }

    chooseAndAddFacet() {
        select_facet_column(this.search_model, ko.unwrap(this.settings_obs), this.context).then((column) => {
            console.log("got cokun:", column);
            var settings = ko.unwrap(this.settings_obs);
            var custom_facets = ko.unwrap(settings.custom_facets) || [];
            custom_facets = custom_facets.filter(function(v) { return v.k != "delete" || v.name != column.column.field_name; });
            custom_facets.push({
                "name": column.column.field_name,
                "caption": column.column.caption,
                "facet_type": column.facet_type || column.column.type,
                "target": column.column.target || null
            });
            if (ko.isObservable(settings.custom_facets) ) {
                settings.custom_facets(custom_facets);
            } else {
                settings.custom_facets = custom_facets;
            }
            //save config
            this.settings_obs(settings);
            this.custom(custom_facets);
            uly.publish("page.savesettings");
            //refresh to recalculate facet if needed
            this.search_model.query_results();
        });
    }

    chooseAndAddControl() {
        select_facet_column(this.search_model, ko.unwrap(this.settings_obs), this.context).then((column) => {
            var settings = ko.unwrap(this.settings_obs);
            var custom_controls = ko.unwrap(settings.custom_controls) || [];
            custom_controls = custom_controls.filter((v)  => { 
                return v.k != "delete" || v.name != column.column.field_name; 
            });
            custom_controls.push({
                "name": column.column.field_name,
                "caption": column.column.caption,
                "facet_type": column.facet_type || column.column.type,
                "target": column.column.target || null
            });

            if (ko.isObservable(settings.custom_controls) ) {
                settings.custom_controls(custom_controls);
            } else {
                settings.custom_controls = custom_controls;
            }
            //save config
            console.log("Settings:", settings)
            this.settings_obs(settings);
            this.custom_controls(custom_controls);
            uly.publish("page.savesettings");
            //refresh to recalculate facet if needed
            this.search_model.query_results();
        });
    }

    removeControl(val) {
        var settings = ko.unwrap(this.settings_obs);
        var custom_controls = ko.unwrap(settings.custom_controls) || [];
        custom_controls = custom_controls.filter(function(v) { return v.name != val.name; });

        if (ko.isObservable(settings.custom_controls)) {
            settings.custom_controls(custom_controls);
        } else {
            settings.custom_controls = custom_controls;
        }
        this.settings_obs(settings);
        this.custom_controls(custom_controls);
        this.panel_widgets(this.panel_widgets().filter((w)=> {return w != val;}));
        uly.publish("page.savesettings");
        this.search_model.query_results();
    }

    upgradeFacet (val) {
        var settings = ko.unwrap(this.settings_obs);
        var custom_facets = ko.unwrap(settings.custom_facets) || [];
        custom_facets = custom_facets.filter(function(v) { return v.name != val.name; });
        custom_facets.push({
            "name": val.name,
            "facet_type": "delete"
        });

        var custom_controls = ko.unwrap(settings.custom_controls) || [];
        custom_controls = custom_controls.filter((v)  => { 
            return v.k != "delete" || v.name != val.name; 
        });

        custom_controls.push({
            "name": val.name,
            "caption": val.caption,
            "facet_type": val.type,
            "target": val.target
        });

        if (ko.isObservable(settings.custom_facets)) {
            settings.custom_facets(custom_facets);
        } else {
            settings.custom_facets = custom_facets;
        }
        if (ko.isObservable(settings.custom_controls)) {
            settings.custom_controls(custom_controls);
        } else {
            settings.custom_controls = custom_controls;
        }

        this.settings_obs(settings);
        this.custom(custom_facets);
        this.custom_controls(custom_controls);
        uly.publish("page.savesettings");
        this.search_model.query_results();
    }

    removeFacet (val) {
        var settings = ko.unwrap(this.settings_obs);
        var custom_facets = ko.unwrap(settings.custom_facets) || [];
        custom_facets = custom_facets.filter(function(v) { return v.name != val.name; });
        custom_facets.push({
            "name": val.name,
            "facet_type": "delete"
        });
        if (ko.isObservable(settings.custom_facets)) {
            settings.custom_facets(custom_facets);
        } else {
            settings.custom_facets = custom_facets;
        }
        this.settings_obs(settings);
        this.custom(custom_facets);
        uly.publish("page.savesettings");
        this.search_model.query_results();
    }

    clearFacets () {
        ko.unwrap(this.settings_obs).custom_facets.splice(0);
        this.custom([]);
    }
    resetFacets () {
        this.clearFacets();
        uly.publish("page.savesettings");
        this.search_model.query_results();
    }

    _buildFacet(facet, expanded, filtered, facet_names, resultFacets, active, is_control) {
        var fidx = facet_names.indexOf(facet.name);
        var f = null;
        if (facet.facet_type != "delete") {
            if ( fidx >= 0) {
                delete facet.data;
                facet = Object.assign({}, resultFacets.facet_fields[fidx], facet);
            }
            let is_filtered = filtered.filter((v) => v[0] == facet.name)[0];
            if (is_filtered) { }
            if (facet.facet_type == "daterange") {
                f = new DateRangeFacet(this.search_model, facet, expanded.indexOf(facet.name) >= 0, active, true, is_control);
            } else if (facet.facet_type == "intrange") {
                f = new IntRangeFacet(this.search_model, facet, expanded.indexOf(facet.name) >= 0, active, true, is_control);
            } else if (facet.facet_type == "numrange") {
                f = new NumRangeFacet(this.search_model, facet, expanded.indexOf(facet.name) >= 0, active, true, is_control);
            } else if (facet.facet_type == "single") {
                f = new MultiFacet(this.search_model, facet, expanded.indexOf(facet.name) >= 0, is_filtered, active, true, is_control);
                
            } else if (facet.facet_type == "text" || facet.facet_type == "string") {
                f = new TextFacet(this.search_model, facet, expanded.indexOf(facet.name) >= 0, active, true, is_control);
            } else {
                f = new MultiFacet(this.search_model, facet, expanded.indexOf(facet.name) >= 0, is_filtered, active, true, is_control);
            }
        }
        return f;
    }

    updateFacetUI (resultFacets) {
        this.updateFacets(resultFacets);
        this.updateControls(resultFacets);
    }

    updateControls (resultFacets) {
        var facets = [];
        var activeFacets = this.active().map((v)=>{return v.selector; });
        var expanded = ko.unwrap(this.panel_widgets).filter( (v) => {
            return ko.unwrap(v.expanded);
        }).map( (v) => {
            return v.name;
        });

        var custom_facets = this.custom_controls().map((f) => { return f.name;});

        var facet_names = [];
        if (resultFacets && resultFacets.facet_fields) {
            facet_names =  resultFacets.facet_fields.map((f) => {
                return f.name;
            });
        }

        this.custom_controls().forEach((facet) => { 
            console.log("Update Cotnrols: custom:", ko.toJS(facet));
            var f = this._buildFacet(facet, expanded, [], facet_names, resultFacets, activeFacets, true) 
            if (f) {
                facets.push(f);
            }
        });
        this.panel_widgets(facets);
    }

    updateFacets (resultFacets) {

        var facets = [];
        var activeFacets = this.active().map((v)=>{return v.selector; });
        var expanded = ko.unwrap(this.widgets).filter( (v) => {
            return ko.unwrap(v.expanded);
        }).map( (v) => {
            return v.name;
        });
        var filtered = ko.unwrap(this.widgets).filter( (v) => {
            return ko.unwrap(v.filtering) 
        }).map( (v) => {
            return [v.name, ko.unwrap(v.current_filter)];
        });

        var custom_facets = this.custom().map((f) => { return f.name;});

        var facet_names = [];
        if (resultFacets && resultFacets.facet_fields) {
            facet_names =  resultFacets.facet_fields.map((f) => {
                return f.name;
            });
        }

        this.custom().forEach((facet) => { 
            console.log("Update Facet: custom:", ko.toJS(facet));
            var f = this._buildFacet(facet, expanded, filtered, facet_names, resultFacets, activeFacets, false) 
            if (f) {
                facets.push(f);
            }
        });

        if (resultFacets && resultFacets.facet_fields) {
            resultFacets.facet_fields.forEach((facet) => {
                var fidx = custom_facets.indexOf(facet.name);
                if ( fidx < 0) {
                    //Object.apply(facet, faceting.custom()[fidx]);
                    //custom_facets.splice(fidx,1);
                    var f = this._buildFacet(facet, expanded, filtered, [], resultFacets, activeFacets, false);
                    facets.push(f);
                }
            });
        }

        this.widgets(facets);
    }

}


function split_by(list, split) {
    let res = [];
    let clist = [];
    list.forEach((v, idx)=>  {
        if ((idx % split == 0) && clist.length > 0) {
            res.push(clist);
            clist = [];
        }
        clist.push(v);
    });
    if (clist.length > 0) {
        res.push(clist);
    }
    return res;
}
function select_facet_column(search_model, search_settings, context) {
    var query = SearchQuery.computeSearchQuery(search_model, search_settings, context);
    var fq = query.fq;
    delete query.fq;
    delete query.cf;
    return uly.api.start()
        .follow("uly:search")
        .follow("uly:availablefacets", {
            "q": query,
            "fq": fq
        })
        .then(function (columns) {
            var columns_data = new search_columns.Columns(columns);
            columns_data.facet_column = ko.observable(null);
            columns_data.selected_column = ko.pureComputed(() => {
                var selectedCol = ko.unwrap(columns_data.facet_column);
                var col = columns_data.flat_columns().filter(function (v) {
                    return v.field_name == selectedCol;
                });
                if (col.length) {
                    selectedCol = col[0];
                }
                if (!selectedCol) {
                    return {
                        "is_int": false,
                        "is_date": false,
                        "is_num": false,
                        "is_lookup": false,
                        "is_text": false
                    };
                }
                return {
                    "column": selectedCol,
                    "is_int": selectedCol.type == "int",
                    "is_date": selectedCol.type == "datetime" || selectedCol.type == "date",
                    "is_num": selectedCol.type == "num",
                    "is_lookup": selectedCol.type == "lookup",
                    "is_text": selectedCol.type == "string" || selectedCol.type == "text"
                };
            });

            return uly.dialogs.execute(
                select_facet_column_dialog, {
                    "title": _("search_select_facet_column_title", "Select Facet Field"),
                    "raw_data": true
                },
                columns_data
            ).then(function ([result]) {
                result.query = query;
                result.fq = fq;
                return ko.unwrap(result.selected_column);
            });
        });
}

export default FacetHelper;
